module.exports = __webpack_public_path__ + "img/vircos-label-sample.fcd41fbf.png";